import { createFileRoute } from '@tanstack/react-router';
import DashboardCanvasLayout from 'containers/Dashboard/components/DashboardCanvasLayout';

export const Route = createFileRoute('/_authenticated/dashboard/roi')({
  component: () => <DashboardCanvasLayout dashboardId="roi" />,
});
